import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../queryKeys';
import { appFeatures } from './AppFeatures';

export const useAppFeatures = () =>
  useQuery({
    queryKey: [QUERY_KEYS.appFeatures],
    queryFn: async () => (await appFeatures.getAppFeatures()).data,
  });

export const useAppDataRules = () =>
  useQuery({
    queryKey: [QUERY_KEYS.appDataRules],
    queryFn: async () => (await appFeatures.getDataRules()).data,
  });
